import React from 'react';
import styled from 'styled-components';

import { Colors } from '@origin-digital/style-guide';

import { SOLAR, BENEFITS, HOME_SUPPORT, EVERYDAY_REWARDS, NO_REWARDS } from '../constants';

export const getPlanTypeFeedback = ({ solar, planType }) => {
  if (solar) {
    return planType === SOLAR
      ? 'Your solar system exports energy back into the grid'
      : 'You use most of your solar power';
  }

  return planType === BENEFITS
    ? 'You want benefits locked in for 12-months'
    : 'You want something you don’t have to renew';
};

export const getRewardTypeFeedback = ({ rewardType }) => {
  switch (rewardType) {
    case HOME_SUPPORT:
      return 'You\'d like a plan with an option to get emergency home assistance';
    case EVERYDAY_REWARDS:
      return 'You want a plan earning Everyday Rewards points';
    case NO_REWARDS:
      // tslint:disable-next-line:max-line-length
      return 'You’re not looking for add-ons to your energy plan right now (Non-Everyday Rewards members can still sign up to this plan – just skip the adding points step on sign-up)';
    default:
      return null;
  }
};

export const List = styled.ul`
  color: ${Colors.GREY};
  padding-inline-start: 1.5em;

  li {
    padding-left: 8px;
    font-size: 14px;
    line-height: 24px;
  }
`;

export const RegurgitatedAnswers = ({ answers }) => {
  const planTypeFeedback = getPlanTypeFeedback(answers);
  const rewardTypeFeedBack = getRewardTypeFeedback(answers);

  return (
    <List>
      <li>{planTypeFeedback}</li>
      {rewardTypeFeedBack && <li>{rewardTypeFeedBack}</li>}
    </List>
  );
};
